var _rect, _path, _path2, _g, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResServiceChannelTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 81,
    viewBox: "0 0 87 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1504,
    y: 17,
    width: 41.7,
    height: 30,
    rx: 4,
    fill: "white",
    stroke: "#2E2E30",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 29H49",
    stroke: "#2E2E30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35H49",
    stroke: "#2E2E30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_566_59363)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 50,
    r: 18,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0003 40.2239C50.6027 40.2239 46.2256 44.2479 46.2256 49.2101C46.2256 52.8752 47.7705 54.6264 49.8853 56.2205C49.886 56.2211 49.8867 56.2215 49.8875 56.2219C49.8923 56.2243 49.8953 56.2292 49.8953 56.2346V60.5275C49.8953 60.7312 50.1296 60.8477 50.2918 60.7245L53.9381 58.032C53.975 58.0048 54.0235 57.9988 54.0659 58.0164C54.0744 58.0199 54.0833 58.0225 54.0923 58.0242C54.7098 58.1368 55.3473 58.1964 56.0003 58.1964C61.3979 58.1964 65.775 54.1724 65.775 49.2079C65.775 44.2434 61.4002 40.2239 56.0003 40.2239Z",
    fill: "#D5D4FF",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1725 51.0888C54.1299 51.0888 54.9499 50.5178 55.1978 49.6378H56.6147C56.2678 51.3329 54.9409 52.4436 53.1725 52.4436C51.118 52.4436 49.4893 50.9209 49.4893 48.8003C49.4893 46.6797 51.118 45.157 53.1725 45.157C54.959 45.157 56.2948 46.2901 56.6237 48.0143H55.2113C54.9973 47.076 54.148 46.4916 53.1725 46.4916C51.7916 46.4916 50.8725 47.4702 50.8725 48.7981C50.8725 50.126 51.9177 51.0866 53.1725 51.0866",
    fill: "#2E2E30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5104 52.3048H61.2106V49.3915C61.2106 48.722 60.8186 48.3615 60.2148 48.3615C59.5413 48.3615 59.1065 48.7713 59.1065 49.602V52.3048H57.8066V45.1794H59.1065V47.8599C59.4174 47.3896 59.922 47.159 60.6068 47.159C61.161 47.159 61.6138 47.3381 61.9652 47.7098C62.3279 48.0793 62.5104 48.5809 62.5104 49.2303V52.3026V52.3048Z",
    fill: "#2E2E30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.72,
    y: 26.72,
    width: 14.56,
    height: 11.56,
    rx: 2.28,
    fill: "white",
    stroke: "#2E2E30",
    strokeWidth: 1.44
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 29C16.72 27.7408 17.7408 26.72 19 26.72H29C30.2592 26.72 31.28 27.7408 31.28 29V31.28H16.72V29Z",
    fill: "#D5D5FF",
    stroke: "#2E2E30",
    strokeWidth: 1.44
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.5V28",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.5V28",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_566_59363",
    x: 25,
    y: 19,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_566_59363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_566_59363",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResServiceChannelTalk);
export default __webpack_public_path__ + "static/media/ic_res_service_channel_talk.63b36e1f19ca396714640d73e580cb00.svg";
export { ForwardRef as ReactComponent };